import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageview } from '../services/analytics';

export default function Analytics() {
    const location = useLocation();

    useEffect(() => {
        const url = location.pathname + location.search;
        pageview(url);
    }, [location]);

    return null;
}
